export const InputLetter= (vl) =>{

    return{
        type:"InputLetter",
        val: vl
    }

}